/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Cell } from "react-table";
import { FlexContainer } from "~/components";
import { EditAssignMemberSidebar } from "~/components/Team/EditAssignMemberSidebar";
import { RolesCell } from "~/components/Team/RolesCell";
import { TeamEmployee } from "~/components/Team/types";
import { UnassignTeamMember } from "~/components/Team/UnassignTeamMember";

import { getEmployeeStatusColor } from "~/tools/display/displayEmployeeColor";

export const TeamMembersListColumns = (
  customerId: string,
  fetchTeam: () => void,
  canEdit: boolean
) => [
  {
    Header: "Name",
    accessor: "lastName",
    disableSortBy: true,
    width: "30%",
    Cell: ({ row }: Cell<TeamEmployee>) => (
      <span style={{ color: getEmployeeStatusColor(row?.original) }}>
        {`${row?.original?.firstName} ${row?.original?.lastName}`}
      </span>
    ),
  },
  {
    Header: "Role",
    accessor: "role",
    disableSortBy: true,
    width: "25%",
    Cell: ({ row }: Cell<TeamEmployee>) => (
      <RolesCell roles={row?.original?.roles} />
    ),
  },
  {
    Header: "Email",
    accessor: "email",
    disableSortBy: true,
    width: "35%",
  },
  {
    Header: () => <div style={{ textAlign: "right" }}>Actions</div>,
    accessor: "actions",
    disableSortBy: true,
    Cell: ({ row }: Cell<TeamEmployee>) => {
      const fullName = `${row?.original.firstName} ${row?.original.lastName}`;

      return (
        <>
          {canEdit && (
            <FlexContainer>
              <EditAssignMemberSidebar
                customerId={customerId}
                employeeId={row?.original.id}
                employeeRoles={row?.original.roles}
                header={fullName}
                refetch={fetchTeam}
              />
              <UnassignTeamMember
                customerId={customerId}
                employeeId={row?.original.id}
                confirmMsg={fullName}
                deleteCallback={fetchTeam}
              />
            </FlexContainer>
          )}
        </>
      );
    },
  },
];
